import React from 'react'
// import LogoImage from '../../../images/logo-xl.png'
import { Image } from 'react-bootstrap'
const LoginInfo = () => {
    return (
        <div className='position-relative z-2'>
            {/* <Image src={LogoImage} alt="logo" /> */}
        </div>
    )
}

export default LoginInfo